import { appActions } from "../actions";
import { addMessage } from "../components/MessageContainer";
import { dispatch, getState } from "../store";
import { API_PATH } from "./api";

export const errorHandler = (error: any, axios: any) => {
  const errorStatus = error?.response?.status;
  if (errorStatus === 200) return;

  const langPack = getState().config.langPack;
  const url = error?.config?.url;
  const errorCode = error?.response?.data?.errorCode;
  const errorText = langPack.hasOwnProperty(url)
    ? langPack[url]
    : langPack.hasOwnProperty(errorCode)
      ? langPack[errorCode]
      : langPack?.genericError;

  const errorGroupPopupWithRetries = [
    "INIT_FORM_FAILED",
    "SAVE_APPLICATION_FAILED",
    "FAILED_GET_APPLICATION_TO_SUBMIT",
    "SUBMIT_APPLICATION_FAILED",
    "INVALID_FILE_TYPE",
    "INVALID_FILE_ACCESS",
    "VIRUS_SCAN_FAILED",
    "FAILED_GET_APPLICATION_TO_UPDATE",
    "UPDATE_APPLICATION_FAILED",
    "DELETE_APPLICATION_FAILED",
    "FAILED_GET_APPLICATION_TO_DELETE_ENTRY",
    "DELETE_FILE_DIRECTORY_FAILED",
    "DELETE_ENTRY_FAILED",
    "FAILED_GET_APPLICATION_TO_CREATE_ENTRY",
    "FAILED_UPDATE_APPLICATION_TO_CREATE_ENTRY",
    "FAILED_GET_APPLICATION_TO_UPDATE_ENTRY",
    "UPDATE_ENTRY_FAILED",
    "FAILED_GET_APPLICATION",
  ];
  const errorGroupPopupWithRetriesAndRecall = ["GET_APPLICATION_FAILED"];
  const urlGroupPopupWithUnlimitedRetries = [API_PATH.ADDRESS];
  const errorGroupPopupWithUnlimitedRetries = [
    "invalid.postal-code",
    "PRIMARY_IMAGE_NOT_ALLOWED_DELETE",
    "INVALID_EXCEED_MAX_1_ENTRY",
  ];
  const errorGroupPopupWithLinkToExtPage = [
    "INVALID_SESSION",
    "IS_VALID_REQUEST_INVALID_COUNTRY",
  ];
  const errorGroupPopupWithLinkToRetrievalPage = [
    "APPLICATION_NOT_FOUND",
    "INVALID_COUNTRY",
    "INVALID_CAPTCHA",
    "EMPTY_CAPTCHA",
  ];

  const errorGroupRedirectToCommonPage = [
    "IS_VALID_REQUEST_INVALID_APP_ID",
    "INVALID.ENTRY_ID",
    "FAILED_DELETING_FILE_DIRECTORY",
  ];
  const errorGroupRedirectToErrPageCustomMessage = [
    "COMPETITION_FINISHED",
    "DRAFT_ENTRY_ALREADY_EXISTS",
    "ENTRY_ALREADY_SUBMITTED",
  ];
  const errorGroupShowInlineError = ["INVALID_DOB"];

  // SCENARIO 1 TMRW-363708
  if (errorGroupPopupWithRetries.includes(errorCode)) {
    let title;
    switch (errorCode) {
      case "INVALID_FILE_TYPE":
        title = "Wrong file type"
        break;
      case "VIRUS_SCAN_FAILED":
        title = "Error Uploading"
        break;
      default:
        title = "";
        break;
    }
    showErrorPopupWithRetries(errorText, title);
    return;
  }

  // SCENARIO 2 TMRW-363708
  if (errorGroupPopupWithRetriesAndRecall.includes(errorCode)) {
    showErrorPopupWithRetriesAndRecall(error, axios, errorText);
    return;
  }

  // SCENARIO 3 TMRW-363879
  if (
    urlGroupPopupWithUnlimitedRetries.includes(url) ||
    errorGroupPopupWithUnlimitedRetries.includes(errorCode)
  ) {
    showErrorPopupWithUnlimitedRetries(errorText);
    return;
  }

  // SCENARIO 4 TMRW-363879
  if (errorGroupPopupWithLinkToExtPage.includes(errorCode)) {
    showErrorPopupWithRedirect(errorText, langPack["poyPublicUrl"]);
    return;
  }

  // SCENARIO 5 TMRW-363879
  if (errorGroupPopupWithLinkToRetrievalPage.includes(errorCode)) {
    if (
      (errorCode === "INVALID_CAPTCHA" || errorCode === "EMPTY_CAPTCHA") &&
      !url.includes("checkvalidity")
    ) {
      return;
    }
    showErrorPopupWithNoActions(errorText);
    return;
  }

  // SCENARIO 6
  if (errorGroupRedirectToCommonPage.includes(errorCode)) {
    redirectToCommonError();
    return;
  }

  //SCENARIO 7
  if (errorGroupRedirectToErrPageCustomMessage.includes(errorCode)) {
    if (errorCode !== "DRAFT_ENTRY_ALREADY_EXISTS") {
      redirectToErrorPage(errorCode);
      return;
    }
    return;
  }

  //SCENARIO 8 inline error shown in the module
  if (errorGroupShowInlineError.includes(errorCode)) {
    return;
  }

  redirectToCommonError(errorText);
};

export const showErrorPopupWithRetries = (errorText: string, title: string) => {
  const errorRetryMax = getState().config.appConfig.errorRetryMax;
  const errorRetryCount = getState().app.errorRetryCount;

  if (errorRetryCount < errorRetryMax) {
    dispatch(appActions.updateErrorRetryCount(errorRetryCount + 1));
    addMessage({
      title: title,
      text: errorText,
      buttons: {
        confirm: "OK",
      },
    });
  } else {
    redirectToCommonError();
  }
};

export const showErrorPopupWithRetriesAndRecall = (
  error: any,
  axios: any,
  errorText = ""
) => {
  const errorRetryMax = getState().config.appConfig.errorRetryMax;
  const errorRetryCount = getState().app.errorRetryCount;

  if (errorRetryCount < errorRetryMax) {
    dispatch(appActions.updateErrorRetryCount(errorRetryCount + 1));
    addMessage({
      text: errorText,
      buttons: {
        confirm: "OK",
      },
      confirmFn: () => {
        // recall GET/POST API with the payload
        axios[error?.config?.method](
          error?.config?.url,
          error?.config?.data && JSON.parse(error?.config?.data)
        );
      },
    });
  } else {
    redirectToCommonError();
  }
};

export const showErrorPopupWithUnlimitedRetries = (errorTextbyUrl = "") => {
  addMessage({
    text: errorTextbyUrl,
    buttons: {
      confirm: "OK",
    },
  });
};

export const showErrorPopupWithRedirect = (
  errorText: string,
  redirectUrl: string
) => {
  addMessage({
    text: errorText,
    buttons: {
      confirm: "OK",
    },
    confirmFn: () => {
      window.location.replace(redirectUrl);
    },
  });
};

export const showErrorPopupWithNoActions = (errorText = "") => {
  addMessage({
    text: errorText,
    noActions: true,
  });
};

export const redirectToCommonError = (errorMsg?: string) => {
  const langPack = getState().config.langPack;
  return dispatch(
    appActions.gotoStep("ServiceError", {
      title: "This service is currently unavailable.",
      content: errorMsg ?? langPack["genericError"],
    })
  );
};

export const redirectToErrorPage = (errorCode: string) => {
  const langPack = getState().config.langPack;
  const competitionFinished = `${langPack["COMPETITION_FINISHED"]}`;
  const entryAlreadySubmitted = `${langPack["ENTRY_ALREADY_SUBMITTED"]} <a href="mailto:${langPack["internalEmailId"]}">${langPack["internalEmailId"]}</a>`;
  return dispatch(
    appActions.gotoStep("Error", {
      title: langPack["labelError"],
      content:
        errorCode === "COMPETITION_FINISHED"
          ? competitionFinished
          : entryAlreadySubmitted,
    })
  );
};
